export const MAIL_RU_PIXEL_ID = 3785678;
export const MAIL_RU_PIXEL_SCRIPT_ID = "tmr-code";

const MAIL_RU_PIXEL_SCRIPT_SRC = "https://top-fwz1.mail.ru/js/code.js";

export const MAIL_RU_PIXEL_GOALS = Object.freeze({
    travelPlan: Object.freeze({ goal: "travel_plan", value: 200 }),
    newUser: Object.freeze({ goal: "new_user", value: 50 }),
});

export const initMailRuPixel = () => {
    if (typeof window === "undefined" || typeof document === "undefined") return false;

    try {
        const queue = window._tmr || (window._tmr = []);
        const existingScript = document.getElementById(MAIL_RU_PIXEL_SCRIPT_ID);

        // В обычном index.html счетчик уже создается статическим сниппетом.
        // В SEO-оболочке его нет, поэтому React безопасно подстраховывает загрузку.
        if (!existingScript) {
            const hasInitialPageView = Array.isArray(queue) && queue.some((event) => (
                event?.type === "pageView" &&
                String(event?.id) === String(MAIL_RU_PIXEL_ID)
            ));

            if (!hasInitialPageView) {
                queue.push({
                    id: String(MAIL_RU_PIXEL_ID),
                    type: "pageView",
                    start: Date.now(),
                });
            }

            const script = document.createElement("script");
            script.id = MAIL_RU_PIXEL_SCRIPT_ID;
            script.type = "text/javascript";
            script.async = true;
            script.src = MAIL_RU_PIXEL_SCRIPT_SRC;
            document.head.appendChild(script);
        }

        return true;
    } catch (error) {
        // Отказ внешней аналитики не должен мешать загрузке приложения.
        console.warn("[Mail.ru Pixel] Не удалось инициализировать счетчик.", error);
        return false;
    }
};

export const trackMailRuGoal = (goal, value) => {
    if (typeof window === "undefined" || !goal) return false;

    try {
        initMailRuPixel();
        const queue = window._tmr || (window._tmr = []);
        queue.push({
            type: "reachGoal",
            id: MAIL_RU_PIXEL_ID,
            value,
            goal,
        });
        return true;
    } catch (error) {
        // Аналитика не должна влиять на основной пользовательский сценарий.
        console.warn(`[Mail.ru Pixel] Не удалось отправить цель «${goal}».`, error);
        return false;
    }
};

export const trackMailRuTravelPlan = () => {
    const { goal, value } = MAIL_RU_PIXEL_GOALS.travelPlan;
    return trackMailRuGoal(goal, value);
};

export const trackMailRuNewUser = () => {
    const { goal, value } = MAIL_RU_PIXEL_GOALS.newUser;
    return trackMailRuGoal(goal, value);
};
